import { render, staticRenderFns } from "./switch-setting.view.vue?vue&type=template&id=e1da8d64"
import script from "./switch-setting.view.vue?vue&type=script&lang=ts"
export * from "./switch-setting.view.vue?vue&type=script&lang=ts"
import style0 from "./switch-setting.view.vue?vue&type=style&index=0&id=e1da8d64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports